import { themeOptionFactory as kioskH } from "./kiosk-h"

export const themeOptionFactories = {
  mobile: null,
  "kiosk-h": kioskH,
  "kiosk-v": null,
}
